var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoFlagOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    fillOpacity: 0.01
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.93 15.75H18C18.825 15.75 19.5 15.075 19.5 14.25V8.25C19.5 7.425 18.825 6.75 18 6.75H15L13.905 4.575C13.665 4.065 13.14 3.75 12.57 3.75H6C5.175 3.75 4.5 4.425 4.5 5.25V19.125C4.5 19.74 5.01 20.25 5.625 20.25C6.24 20.25 6.75 19.74 6.75 19.125V12.75H10.5L11.595 14.925C11.835 15.435 12.36 15.75 12.93 15.75Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoFlagOutline);
export default __webpack_public_path__ + "static/media/ico-flag-outline.8dcc6c69efe65d36773699d5013423b0.svg";
export { ForwardRef as ReactComponent };